// ABOUTME: Daily behavior timeline with date navigation controls
// ABOUTME: Wraps AnalyticsTimeChart with prev/next day navigation and date picker

import React from 'react';
import {
  Box,
  Paper,
  Typography,
  IconButton,
  TextField
} from '@mui/material';
import {
  ArrowBack,
  ArrowForward,
  Timeline
} from '@mui/icons-material';
import AnalyticsTimeChart from '../AnalyticsTimeChart';
import { getTodayInFamilyTimezone } from '../../utils/dateUtils';

interface TimelineSectionProps {
  timelineChild: {
    childId: number;
    id: number;
    name: string;
    profileImageUrl?: string;
    createdAt: string;
    birthYear: number;
  } | null;
  selectedTimelineDate: string;
  familyId: number;
  familyTimezone?: string;
  onNavigateDate: (direction: 'prev' | 'next') => void;
  onDateChange: (date: string) => void;
}

const TimelineSection: React.FC<TimelineSectionProps> = ({
  timelineChild,
  selectedTimelineDate,
  familyId,
  familyTimezone,
  onNavigateDate,
  onDateChange
}) => {
  const today = getTodayInFamilyTimezone(familyTimezone);
  const isToday = selectedTimelineDate >= today;

  // Calculate min date from child's creation date (YYYY-MM-DD format)
  const minDate = timelineChild?.createdAt ? timelineChild.createdAt.split('T')[0] : undefined;

  return (
    <Box sx={{ mt: 4 }} data-testid="timeline-section">
      <Paper sx={{ p: 3 }}>
        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Timeline />
            Daily Behavior Timeline
          </Typography>

          {/* Date Navigation Controls */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton onClick={() => onNavigateDate('prev')} size="small" aria-label="Previous day">
              <ArrowBack />
            </IconButton>
            <TextField
              type="date"
              value={selectedTimelineDate}
              onChange={(e) => onDateChange(e.target.value)}
              size="small"
              inputProps={{ min: minDate, max: today }}
            />
            <IconButton
              onClick={() => onNavigateDate('next')}
              size="small"
              disabled={isToday}
              aria-label="Next day"
            >
              <ArrowForward />
            </IconButton>
          </Box>
        </Box>

        {timelineChild && (
          <AnalyticsTimeChart
            child={timelineChild}
            selectedDate={selectedTimelineDate}
            timeWindow={isToday ? 'Today' : { type: 'custom', startDate: selectedTimelineDate, endDate: selectedTimelineDate }}
            familyId={familyId}
            familyTimezone={familyTimezone}
            isAdminContext={true}
          />
        )}
      </Paper>
    </Box>
  );
};

export default TimelineSection;
